import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';

@Component({
  selector: 'pm-ruteos-list',
  templateUrl: './ruteos-list.component.html',
  styleUrls: ['./ruteos-list.component.sass']
})
export class RuteosListComponent {
  public pageTitle = 'RUTEOS';

  public showRuteos = true;
  public showAddRuteo = false;
  public showEditRuteo = false;
  public editnumber = 0;
}
